(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[301],{

/***/ 6947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[collection_handle]",
      function () {
        return __webpack_require__(1605);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ProductData; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);


const ProductData = (param)=>{
    let { product  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ProductJsonLd */ .Qb, {
        productName: product.title,
        description: product.description,
        brand: "Blickfang",
        images: product.images.edges.map((image)=>image.node.url),
        offers: [
            {
                price: product.variants.edges[0].node.priceV2.amount,
                priceCurrency: product.variants.edges[0].node.priceV2.currencyCode,
                url: "https://blckfng.com/items/" + product.handle,
                itemCondition: "https://schema.org/NewCondition",
                availability: product.availableForSale ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
            }
        ]
    });
};


/***/ }),

/***/ 1605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8641);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_shopping_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4764);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2962);
/* harmony import */ var _utils_image_loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3600);
/* harmony import */ var _json_ld_product__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5077);









// @ts-ignore collections prop used for header
const CollectionPage = (param)=>{
    let { collection , collections  } = param;
    var ref;
    const [currentHover, setCurrentHover] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_seo__WEBPACK_IMPORTED_MODULE_5__/* .NextSeo */ .PB, {
                title: collection.title + " - Blickfang",
                openGraph: {
                    type: "website",
                    locale: "de_DE",
                    title: collection.title + " - Blickfang",
                    images: [
                        {
                            url: (ref = collection.image) === null || ref === void 0 ? void 0 : ref.url
                        }
                    ]
                },
                twitter: {
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                pb: "40px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6, {
                        w: "100%",
                        textAlign: "center",
                        pt: "20px",
                        children: collection.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .SimpleGrid */ .MI, {
                        columns: {
                            sm: 2,
                            md: 3
                        },
                        p: "10px",
                        w: "100%",
                        spacing: "10px",
                        children: collection.products.edges.map((edge, index)=>{
                            const product = edge.node;
                            var _altText, _altText1;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/items/" + product.handle,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .gC, {
                                        cursor: "pointer",
                                        overflow: "hidden",
                                        spacing: "10px",
                                        justify: "space-between",
                                        maxH: "80vh",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .AspectRatio */ .oM, {
                                                onMouseOver: ()=>setCurrentHover(product.id),
                                                onMouseOut: ()=>setCurrentHover(""),
                                                ratio: 0.6,
                                                w: [
                                                    "90vw",
                                                    "100%"
                                                ],
                                                overflow: "hidden",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            loader: _utils_image_loader__WEBPACK_IMPORTED_MODULE_8__/* .shopifyImageLoader */ .P,
                                                            src: product.images.edges[0].node.url,
                                                            fill: true,
                                                            sizes: "(max-width: 460px) 90vw, 30vw",
                                                            quality: "60",
                                                            priority: index === 0,
                                                            style: {
                                                                objectFit: "cover",
                                                                objectPosition: "center"
                                                            },
                                                            alt: (_altText = product.images.edges[0].node.altText) !== null && _altText !== void 0 ? _altText : ""
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            loader: _utils_image_loader__WEBPACK_IMPORTED_MODULE_8__/* .shopifyImageLoader */ .P,
                                                            src: product.images.edges[product.images.edges.length - 1].node.url,
                                                            fill: true,
                                                            sizes: "(max-width: 460px) 90vw, 30vw",
                                                            quality: "60",
                                                            style: {
                                                                objectFit: "cover",
                                                                objectPosition: "center",
                                                                opacity: currentHover === product.id ? "1" : "0",
                                                                transition: "opacity 0.3s"
                                                            },
                                                            alt: (_altText1 = product.images.edges[product.images.edges.length - 1].node.altText) !== null && _altText1 !== void 0 ? _altText1 : ""
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                                pl: "3px",
                                                w: [
                                                    "90vw",
                                                    "100%"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Heading */ .X6, {
                                                        pt: "10px",
                                                        size: "md",
                                                        m: 0,
                                                        w: "100%",
                                                        children: product.title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
                                                        w: "100%",
                                                        mb: "20px",
                                                        spacing: "4",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
                                                                color: "gray.400",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("b", {
                                                                    children: [
                                                                        (0,_utils_shopping_cart__WEBPACK_IMPORTED_MODULE_4__/* .formatCurrencyString */ .oS)(product.variants.edges[0].node.priceV2.amount),
                                                                        "*"
                                                                    ]
                                                                })
                                                            }),
                                                            !edge.node.availableForSale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Badge */ .Ct, {
                                                                variant: "outline",
                                                                children: "Ausverkauft"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_json_ld_product__WEBPACK_IMPORTED_MODULE_6__/* .ProductData */ .e, {
                                        product: product
                                    })
                                ]
                            }, product.id);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CollectionPage);


/***/ }),

/***/ 3600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ shopifyImageLoader; }
/* harmony export */ });
const shopifyImageLoader = (param)=>{
    let { src , width  } = param;
    if (src.startsWith("https://cdn.shopify.com")) {
        return "".concat(src, "&width=").concat(width);
    } else return src;
};



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,962,888,179], function() { return __webpack_exec__(6947); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);